import { Controller } from "stimulus"
import Rails from "@rails/ujs";
import { buildValidationFormData, postValidation, failureMessage } from '../services/form_helper'

export default class extends Controller {
  static targets = [ "form","password","passwordToggleHide","passwordToggleShow" ];
  static classes = ["hide",'errorm','readonly'];
  static values = {validateurl: String, validateflag: String, networkErrorMessage: String};

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    // YAS-31 FR-2: 実ファイルではなく1バイトの代理ファイルを送る（空body送信の回避）
    const formData = buildValidationFormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }
  validateAll(){
    let errorMs = document.querySelectorAll("."+this.errormClass);
    const allErrorE = document.getElementById("allError");
    // YAS-31 FR-3: 旧実装は error コールバックが無く、失敗すると無言で何も起きなかった
    postValidation({
      url: this.validateurlValue,
      buildFormData: () => buildValidationFormData(this.formTarget),
      onSuccess: (response)=> {
        if(Object.keys(response).length > 0){
          let allErrorTxt = "";
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
                allErrorTxt += response[key]+"<br />";
              }
            })
          });
          allErrorE.innerHTML = allErrorTxt;
          allErrorE.classList.remove(this.hideClass);
        }else{
          allErrorE.innerHTML = '';
          allErrorE.classList.add(this.hideClass);
          this.formTarget.submit();
        }
      },
      onFailure: (response)=> {
        allErrorE.innerHTML = failureMessage(response, this.networkErrorMessageValue);
        allErrorE.classList.remove(this.hideClass);
      }
    });
  }

  password_toggle(event){
    const params = event.params;
    let input;
    let showIcon;
    let hideIcon;
    input = this.passwordTarget;
    showIcon = this.passwordToggleShowTarget;
    hideIcon = this.passwordToggleHideTarget;
    //if password hide
    if(showIcon.classList.contains(this.hideClass)){
      input.type = "text";
    }else {
      input.type = "password";
    }
    showIcon.classList.toggle(this.hideClass);
    hideIcon.classList.toggle(this.hideClass);
  }

}
